
import { defineComponent, PropType } from 'vue';
import { Field } from 'vee-validate';
import { RequestAccessFormModel } from '@/b2b/request-access/use-request-access';

export default defineComponent({
    name: 'ProfileRequestAccessFormRenderer',
    components: { Field },
    props: {
        formElements: {
            type: Array as PropType<RequestAccessFormModel>,
            required: true,
        },
    },
});
